import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { PageHeader, Loading, Empty, Plate, DemoTag, ExportBtn, useFetch } from "@/components/common";
import { fEur, fKm, fDate } from "@/lib/api";

function Table({ rows, testid, title }) {
  return (
    <div className="mb-8">
      <h2 className="font-display font-bold text-[#0E2D43] text-base md:text-lg mb-3">{title}</h2>
      {!rows.length ? <Empty /> : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto rise">
          <table className="tbl w-full" data-testid={testid}>
            <thead><tr><th>Nom</th><th>Véhicule affecté</th><th>Depuis</th><th>Historique véhicules</th><th className="text-right">Dernier km</th>
              <th className="text-right">Dépenses année</th><th className="text-right">dont Fleet Pro</th><th className="text-right">Km année</th><th className="text-right">Km perso année</th><th></th></tr></thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id} data-testid={`commercial-row-${c.id}`}>
                  <td><div className="font-semibold text-[#0E2D43] flex items-center gap-2">{c.name}<DemoTag show={c.is_demo} /></div><div className="text-xs text-slate-500">{c.job_title || c.email || <span className="text-amber-600">e-mail à renseigner</span>}</div></td>
                  <td>{c.vehicle ? <div className="flex items-center gap-2"><Plate>{c.vehicle.plate}</Plate><span className="text-xs text-slate-500">{c.vehicle.brand} {c.vehicle.model}{c.vehicle.engine ? ` · ${c.vehicle.engine}` : ""}</span></div> : <span className="text-slate-400">Aucun</span>}</td>
                  <td>{fDate(c.assigned_since)}</td>
                  <td className="text-xs text-slate-500">{c.vehicle_history.map((h) => `${h.plate} (${fDate(h.start_date)} → ${h.end_date ? fDate(h.end_date) : "…"})`).join(" · ") || "—"}</td>
                  <td className="text-right tabular-nums">{c.vehicle?.mileage ? fKm(c.vehicle.mileage) : "—"}</td>
                  <td className="text-right tabular-nums font-semibold">{fEur(c.stats.spend_year, 0)}</td>
                  <td className="text-right tabular-nums">{fEur(c.stats.spend_fleetpro, 0)}</td>
                  <td className="text-right tabular-nums">{fKm(c.stats.km_year)}</td>
                  <td className="text-right tabular-nums">{fKm(c.stats.perso_year)}</td>
                  <td><Link to={`/commerciaux/equipe/${c.id}`} className="inline-flex items-center text-xs font-bold text-[#E0830B] hover:underline" data-testid={`commercial-open-${c.id}`}>Fiche <ChevronRight className="w-3 h-3" /></Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default function Commerciaux() {
  const { data, loading } = useFetch("/commerciaux");
  const rows = data || [];
  return (
    <div data-testid="commerciaux-page">
      <PageHeader overline="Véhicules commerciaux" title="Commerciaux">
        <ExportBtn path="/export/commerciaux" filename="synthese-commerciaux.xlsx" testid="export-commerciaux" />
      </PageHeader>
      {loading ? <Loading /> : (
        <>
          <Table title="Commerciaux" testid="commerciaux-table" rows={rows.filter((c) => c.category !== "technicien")} />
          <Table title="Technicien / Chef de dépôt" testid="techniciens-table" rows={rows.filter((c) => c.category === "technicien")} />
        </>
      )}
    </div>
  );
}
